import styled from 'styled-components'

import crossIcon from 'assets/images/femi-cross.svg'

import { FemiColor } from '../../constants'

export const StyledFemiFeedbackPopup = {
  Overlay: styled.div`
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: var(--full-height, 100vh);
    padding: 24px;
    background-color: rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(16px);
    -webkit-backdrop-filter: blur(16px);
  `,
  Content: styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
    max-width: 342px;
    padding: 24px;
    border-radius: 20px;
    background-color: ${FemiColor.WHITE};
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  `,
  Headline: styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
  `,
  Buttons: styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
  `,
  CloseButton: styled.button`
    position: absolute;
    top: 24px;
    inset-inline-end: 24px;
    width: 32px;
    height: 32px;
    padding: 0;
    border: none;
    border-radius: 50%;
    outline: none;
    background-color: ${FemiColor.GRAY_BG};
    background-image: url(${crossIcon});
    background-position: center;
    background-repeat: no-repeat;
    background-size: 24px;
    cursor: pointer;
  `,
  Description: styled.p`
    color: ${FemiColor.GRAY};
    font-size: 15px;
    font-weight: 400;
    line-height: 22px;
    text-align: center;
  `,
  Textarea: styled.textarea`
    width: 100%;
    height: 140px;
    padding: 12px;
    border: 1px solid ${FemiColor.BLACK};
    border-radius: 16px;
    outline: none;
    resize: none;
    color: ${FemiColor.BLACK};
    font-size: 15px;
    font-weight: 400;
    line-height: 22px;

    &::placeholder {
      color: ${FemiColor.GRAY};
    }
  `,
}
